module.exports = __webpack_public_path__ + "assets/img/k-c-1.d4c0e19d.png";